import isBrowser from '../isBrowser';
import { DataLayer } from '../../types/google-events';

const sendGoogleEvent = (event: DataLayer) => {
  if (isBrowser()) {
    return window?.dataLayer?.push({
      event: event.name,
      ...event.data,
    });
  }

  return null;
};

export default sendGoogleEvent;
